import React, { useEffect, useRef, useState } from 'react'
import { Tabs, Swiper } from 'antd-mobile'
import general from '../../../general'
import Dialog from '../../../lib/Dialog'
import ExclusivePrivilegesItem from './ExclusivePrivilegesItem'

export default function ExclusivePrivileges(props) {

  const swiperRef = useRef()
  const [activeIndex, setActiveIndex] = useState(0)
  const [data, setData] = useState([])

  useEffect(()=>{
    setActiveIndex(props.query?.index)
  },[props.query.index])

  const getData = () => {
    Dialog.loading()
    general.axios.post('/honorLevelDesc')
      .finally(() => {
        Dialog.close()
      })
      .then(res => {
        const { status, data } = res.data
        if (status.succeed) {
          setData(data)
        } else {
          Dialog.error(status.error_desc)
        }
      })
  }

  useEffect(() => {
    if (props.active) {
      getData()
    }
  }, [props.active])

  return (
    <div className="exclusive-privileges-index">
      {data.length > 0 && <div className="container">
        <div className="topimage" style={{
          backgroundImage: 'url(/resources/modifyprice/top.png)',
          backgroundSize: '100% 100%',
        }}></div>
        <div className="content">
          <Tabs
            activeLineMode='fixed'
            style={{
              '--active-line-height': '3px',
              '--fixed-active-line-width': '25px',
              '--active-line-border-radius': '1.5px',
              '--active-line-color': '#FFE8B8',
            }}
            className='exclusive-privileges-tabs'
            stretch={false}
            activeKey={data[activeIndex].index.toString()}
            onChange={idx => {
              setActiveIndex(idx - 1)
              swiperRef.current?.swipeTo(idx - 1)
            }}
          >
            {data.map(item => (
              <Tabs.Tab title={item.title} key={item.index} />
            ))}
          </Tabs>
          <div className='exclusive-privileges-swiper-container'>
            <Swiper
              className='exclusive-privileges-swiper'
              direction='horizontal'
              allowTouchMove={false}
              indicator={() => null}
              ref={swiperRef}
              defaultIndex={activeIndex}
              onIndexChange={index => {
                setActiveIndex(index)
              }}
            >
              {data.map(item => {
                return (
                  <Swiper.Item>
                    <ExclusivePrivilegesItem level={props.query.level} item={item}></ExclusivePrivilegesItem>
                  </Swiper.Item>
                )
              })}
            </Swiper>
          </div>
        </div>
      </div>}
    </div>
  )
}
